import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

const B = '#1A1A1A';
const R = '#DD0000';
const G = '#FFCE00';
const W = '#FFFFFF';

const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=Instrument+Serif:ital@0;1&family=Space+Grotesk:wght@300;400;500;600&display=swap');
  :root { --black:#1A1A1A; --red:#DD0000; --gold:#FFCE00; --white:#FFFFFF; }
  *, *::before, *::after { box-sizing: border-box; }
  html { scroll-behavior: smooth; }
  body { overflow-x: hidden; }
  .db-font-display { font-family: 'Instrument Serif', Georgia, serif; }
  .db-font-heading { font-family: 'Syne', sans-serif; }
  .db-font-body    { font-family: 'Space Grotesk', sans-serif; }
  .db-hero-bg {
    background: #1A1A1A;
    background-image:
      radial-gradient(ellipse 80% 60% at 50% -20%, rgba(221,0,0,0.18) 0%, transparent 70%),
      radial-gradient(ellipse 60% 40% at 80% 80%, rgba(255,206,0,0.08) 0%, transparent 60%);
  }
  @keyframes db-float-a { 0%,100%{transform:translateY(0) rotate(0deg);} 33%{transform:translateY(-18px) rotate(4deg);} 66%{transform:translateY(-8px) rotate(-3deg);} }
  @keyframes db-float-b { 0%,100%{transform:translateY(0) rotate(0deg);} 40%{transform:translateY(-24px) rotate(-5deg);} 80%{transform:translateY(-10px) rotate(2deg);} }
  @keyframes db-float-c { 0%,100%{transform:translateY(0) rotate(0deg);} 50%{transform:translateY(-15px) rotate(6deg);} }
  @keyframes db-spin-slow { from{transform:rotate(0deg);} to{transform:rotate(360deg);} }
  @keyframes db-pulse-ring { 0%{transform:scale(0.8);opacity:0.8;} 100%{transform:scale(2.4);opacity:0;} }
  @keyframes db-shimmer { 0%{background-position:-200% center;} 100%{background-position:200% center;} }
  @keyframes db-fade-up { from{opacity:0;transform:translateY(32px);} to{opacity:1;transform:translateY(0);} }
  @keyframes db-fade-in { from{opacity:0;} to{opacity:1;} }
  @keyframes db-particle { 0%{transform:translateY(0) translateX(0) scale(1);opacity:0.6;} 100%{transform:translateY(-120px) translateX(20px) scale(0);opacity:0;} }
  @keyframes db-menu-in { from{opacity:0;transform:translateY(-8px);} to{opacity:1;transform:translateY(0);} }
  .db-hero-label { animation:db-fade-up 0.6s ease 0.1s both; }
  .db-hero-title { animation:db-fade-up 0.7s ease 0.25s both; }
  .db-hero-sub   { animation:db-fade-up 0.6s ease 0.45s both; }
  .db-hero-btns  { animation:db-fade-up 0.6s ease 0.65s both; }
  .db-hero-stats { animation:db-fade-up 0.6s ease 0.85s both; }
  .db-hero-vis   { animation:db-fade-in 1.2s ease 0.4s both; }
  .db-word-a { animation:db-float-a 6s ease-in-out infinite; }
  .db-word-b { animation:db-float-b 8s ease-in-out infinite; }
  .db-word-c { animation:db-float-c 7s ease-in-out infinite; }
  .db-word-d { animation:db-float-b 9s ease-in-out 1s infinite; }
  .db-word-e { animation:db-float-a 5s ease-in-out 2s infinite; }
  .db-shimmer {
    background: linear-gradient(90deg,#FFCE00 0%,#fff8b0 40%,#FFCE00 60%,#d4a800 100%);
    background-size:200% auto;
    -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
    animation:db-shimmer 3s linear infinite;
  }
  .db-reveal { opacity:0; transform:translateY(40px); transition:opacity 0.75s cubic-bezier(.16,1,.3,1),transform 0.75s cubic-bezier(.16,1,.3,1); }
  .db-reveal.db-visible { opacity:1; transform:translateY(0); }
  .db-card-3d { transition:transform 0.15s ease,box-shadow 0.15s ease; transform-style:preserve-3d; will-change:transform; }
  .db-particle { animation:db-particle linear infinite; }
  .db-ring     { animation:db-spin-slow 18s linear infinite; }
  .db-ring-rev { animation:db-spin-slow 12s linear infinite reverse; }
  .db-pulse::before,.db-pulse::after {
    content:''; position:absolute; inset:0; border-radius:inherit;
    border:2px solid #DD0000; animation:db-pulse-ring 2s ease-out infinite;
  }
  .db-pulse::after { animation-delay:1s; }
  .db-nav-scrolled { background:rgba(26,26,26,0.96)!important; backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px); box-shadow:0 1px 0 rgba(255,255,255,0.06); }
  .db-mobile-menu { animation:db-menu-in 0.2s ease both; }
  .db-step-line-h::after { content:''; position:absolute; top:24px; left:50%; width:0; height:2px; background:linear-gradient(90deg,#DD0000,#FFCE00); transition:width 1.2s ease; z-index:0; }
  .db-step-line-h.db-visible::after { width:100%; }
  .db-flag { display:flex; flex-direction:column; overflow:hidden; border-radius:2px; }
  ::-webkit-scrollbar { width:5px; }
  ::-webkit-scrollbar-track { background:#1A1A1A; }
  ::-webkit-scrollbar-thumb { background:#DD0000; border-radius:3px; }
  @media (max-width:639px) {
    .db-ring,.db-ring-rev,.db-word-a,.db-word-b,.db-word-c,.db-word-d,.db-word-e,.db-particle,
    .db-pulse::before,.db-pulse::after { animation:none; }
    a,button { min-height:44px; }
  }
  @media (prefers-reduced-motion:reduce) {
    *,*::before,*::after { animation-duration:0.01ms!important; transition-duration:0.01ms!important; }
  }
`;

function useScrollReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.db-reveal,.db-step-line-h');
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('db-visible'); }),
      { threshold: 0.12 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);
}

function useCounter(target, active, duration=1800) {
  const [val,setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    const start = performance.now();
    const tick = now => {
      const p = Math.min((now-start)/duration,1);
      setVal(Math.round((1-Math.pow(1-p,3))*target));
      if (p<1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  },[active,target,duration]);
  return val;
}

function TiltCard({ children, className='', style={}, isMobile=false }) {
  const ref = useRef(null);
  const move = useCallback(e => {
    if (isMobile) return;
    const el = ref.current; if (!el) return;
    const {left,top,width,height} = el.getBoundingClientRect();
    const x=((e.clientX-left)/width -0.5)*14, y=((e.clientY-top)/height-0.5)*-14;
    el.style.transform=`perspective(600px) rotateY(${x}deg) rotateX(${y}deg) scale(1.02)`;
    el.style.boxShadow=`${-x*2}px ${y*2}px 32px rgba(221,0,0,0.14)`;
  },[isMobile]);
  const leave = useCallback(() => { const el=ref.current; if(el){el.style.transform='';el.style.boxShadow='';} },[]);
  return <div ref={ref} className={`db-card-3d ${className}`} style={style} onMouseMove={move} onMouseLeave={leave}>{children}</div>;
}

function StatCounter({value,label,suffix=''}) {
  const ref=useRef(null), [go,setGo]=useState(false), cnt=useCounter(value,go);
  useEffect(()=>{ const obs=new IntersectionObserver(([e])=>{if(e.isIntersecting)setGo(true);},{threshold:0.5}); if(ref.current)obs.observe(ref.current); return()=>obs.disconnect(); },[]);
  return (
    <div ref={ref} style={{textAlign:'center'}}>
      <div className="db-font-heading" style={{fontSize:'clamp(26px,6vw,38px)',fontWeight:800,color:G,lineHeight:1}}>{cnt}{suffix}</div>
      <div className="db-font-body" style={{fontSize:11,color:'rgba(255,255,255,0.5)',marginTop:4,whiteSpace:'nowrap'}}>{label}</div>
    </div>
  );
}

function Particles({mobile}) {
  if (mobile) return null;
  const ps=Array.from({length:16},(_,i)=>({id:i,left:`${Math.random()*100}%`,size:Math.random()*4+2,duration:Math.random()*6+4,delay:Math.random()*8,color:i%3===0?R:i%3===1?G:'rgba(255,255,255,0.3)'}));
  return (
    <div style={{position:'absolute',inset:0,overflow:'hidden',pointerEvents:'none'}}>
      {ps.map(p=><div key={p.id} className="db-particle" style={{position:'absolute',bottom:'-10px',left:p.left,width:p.size,height:p.size,borderRadius:'50%',background:p.color,animationDuration:`${p.duration}s`,animationDelay:`${p.delay}s`}}/>)}
    </div>
  );
}

function HeroVisual() {
  return (
    <div className="db-hero-vis" style={{position:'relative',width:400,height:400}}>
      <div className="db-ring" style={{position:'absolute',inset:0,border:'1px dashed rgba(221,0,0,0.35)',borderRadius:'50%'}}/>
      <div className="db-ring-rev" style={{position:'absolute',inset:34,border:`1px solid rgba(255,206,0,0.22)`,borderRadius:'50%'}}/>
      <div className="db-ring" style={{position:'absolute',inset:78,border:'1px solid rgba(255,255,255,0.08)',borderRadius:'50%',animationDuration:'25s'}}/>
      <div className="db-pulse" style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width:106,height:106,borderRadius:'50%',background:`radial-gradient(circle at 35% 35%,${R},#8B0000)`,boxShadow:`0 0 48px rgba(221,0,0,0.4)`,display:'flex',alignItems:'center',justifyContent:'center',zIndex:10}}>
        <div className="db-flag" style={{width:46,height:32,border:'2px solid rgba(255,255,255,0.2)'}}>
          <div style={{flex:1,background:B}}/><div style={{flex:1,background:R}}/><div style={{flex:1,background:G}}/>
        </div>
      </div>
      {[{top:'4%',left:'48%',color:R,size:9},{top:'48%',left:'96%',color:G,size:7},{top:'92%',left:'52%',color:W,size:5},{top:'52%',left:'2%',color:R,size:8}].map((d,i)=>(
        <div key={i} style={{position:'absolute',top:d.top,left:d.left,width:d.size,height:d.size,borderRadius:'50%',background:d.color,boxShadow:`0 0 10px ${d.color}`,transform:'translate(-50%,-50%)'}}/>
      ))}
      {[{text:'Hallo',cls:'db-word-a',top:'8%',left:'60%',size:17,color:G},{text:'Danke',cls:'db-word-b',top:'72%',left:'66%',size:15,color:W},{text:'Gut',cls:'db-word-c',top:'18%',left:'7%',size:21,color:R},{text:'Schön',cls:'db-word-d',top:'80%',left:'7%',size:14,color:G},{text:'Ja!',cls:'db-word-e',top:'50%',left:'76%',size:19,color:W}].map((w,i)=>(
        <div key={i} className={`db-font-display ${w.cls}`} style={{position:'absolute',top:w.top,left:w.left,fontSize:w.size,fontStyle:'italic',color:w.color,opacity:0.82,textShadow:`0 0 18px ${w.color}55`,userSelect:'none'}}>{w.text}</div>
      ))}
    </div>
  );
}

function Hamburger({open,onToggle}) {
  return (
    <button onClick={onToggle} aria-label={open?'Close menu':'Open menu'} style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',gap:5,width:44,height:44,background:'transparent',border:'none',cursor:'pointer',padding:8,borderRadius:8,flexShrink:0}}>
      {[0,1,2].map(i=>(
        <span key={i} style={{display:'block',width:open&&i===1?0:22,height:2,background:W,borderRadius:2,transition:'all 0.25s ease',transform:open?(i===0?'translateY(7px) rotate(45deg)':i===2?'translateY(-7px) rotate(-45deg)':'none'):'none',opacity:open&&i===1?0:1}}/>
      ))}
    </button>
  );
}

export default function LandingPage() {
  const [scrolled,setScrolled]=useState(false);
  const [menuOpen,setMenuOpen]=useState(false);
  const [isMobile,setIsMobile]=useState(false);
  const [isTablet,setIsTablet]=useState(false);

  useScrollReveal();

  useEffect(()=>{
    const check=()=>{
      const w=window.innerWidth;
      setScrolled(window.scrollY>60);
      setIsMobile(w<640);
      setIsTablet(w>=640&&w<1024);
    };
    check();
    window.addEventListener('scroll',check,{passive:true});
    window.addEventListener('resize',check,{passive:true});
    return()=>{ window.removeEventListener('scroll',check); window.removeEventListener('resize',check); };
  },[]);

  useEffect(()=>{ if(!isMobile)setMenuOpen(false); },[isMobile]);

  const scrollTo=id=>{ setMenuOpen(false); setTimeout(()=>document.getElementById(id)?.scrollIntoView({behavior:'smooth'}),10); };

  const SL=({text,color=R})=>(
    <span style={{display:'block',fontSize:11,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color,marginBottom:10}}>{text}</span>
  );

  const cols=(mob,tab,desk)=>isMobile?mob:isTablet?tab:desk;

  return (
    <div className="db-font-body" style={{background:B,color:W,overflowX:'hidden'}}>
      <style>{GLOBAL_CSS}</style>

      {/* ── NAVBAR ────────────────────────────────────────── */}
      <nav className={scrolled?'db-nav-scrolled':''} style={{position:'fixed',top:0,left:0,right:0,zIndex:200,background:scrolled?undefined:'transparent',transition:'background 0.3s ease'}}>
        <div style={{maxWidth:1200,margin:'0 auto',height:62,display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 16px'}}>
          <Link to="/" style={{display:'flex',alignItems:'center',gap:9,textDecoration:'none',flexShrink:0}}>
            <div className="db-flag" style={{width:22,height:16,boxShadow:'0 1px 4px rgba(0,0,0,0.4)',flexShrink:0}}>
              <div style={{flex:1,background:B}}/><div style={{flex:1,background:R}}/><div style={{flex:1,background:G}}/>
            </div>
            <span className="db-font-heading" style={{fontSize:16,fontWeight:800,letterSpacing:'-0.3px',lineHeight:1}}>
              <span style={{color:G}}>Deutsch</span><span style={{color:W}}>Bridge</span>
            </span>
            {!isMobile&&<span className="db-font-body" style={{fontSize:10,color:'rgba(255,255,255,0.38)',fontWeight:500,letterSpacing:'0.5px',textTransform:'uppercase'}}>Institute</span>}
          </Link>
          {!isMobile&&(
            <div style={{display:'flex',alignItems:'center',gap:20}}>
              <a href="tel:0202071417" style={{fontSize:13,color:'rgba(255,255,255,0.6)',textDecoration:'none'}}>📞 0202071417</a>
              <Link to="/login" style={{padding:'9px 20px',background:R,color:W,textDecoration:'none',borderRadius:8,fontSize:13,fontWeight:700,fontFamily:'Syne,sans-serif',minHeight:38,display:'inline-flex',alignItems:'center'}}
                onMouseEnter={e=>e.currentTarget.style.background='#BB0000'}
                onMouseLeave={e=>e.currentTarget.style.background=R}
              >Login to LMS →</Link>
            </div>
          )}
          {isMobile&&<Hamburger open={menuOpen} onToggle={()=>setMenuOpen(p=>!p)}/>}
        </div>
        {isMobile&&menuOpen&&(
          <div className="db-mobile-menu" style={{background:'rgba(18,18,18,0.98)',backdropFilter:'blur(24px)',borderTop:'1px solid rgba(255,255,255,0.07)',padding:'8px 16px 16px'}}>
            {[
              {label:'🔐 Login to LMS',to:'/login'},
              {label:'🚀 Enroll Now',to:'/enroll'},
            ].map((item,i)=>(
              <Link key={i} to={item.to} onClick={()=>setMenuOpen(false)} style={{display:'flex',alignItems:'center',padding:'13px 8px',color:i===0?G:W,textDecoration:'none',fontSize:15,fontWeight:600,fontFamily:'Syne,sans-serif',borderBottom:'1px solid rgba(255,255,255,0.06)'}}>
                {item.label}
              </Link>
            ))}
            {[{label:'📚 View Courses',id:'courses'},{label:'📞 Contact Us',id:'contact'}].map((item,i)=>(
              <button key={i} onClick={()=>scrollTo(item.id)} style={{display:'flex',alignItems:'center',width:'100%',padding:'13px 8px',color:W,background:'transparent',border:'none',borderBottom:i===0?'1px solid rgba(255,255,255,0.06)':'none',textAlign:'left',fontSize:15,fontWeight:600,fontFamily:'Syne,sans-serif',cursor:'pointer'}}>
                {item.label}
              </button>
            ))}
            <a href="tel:0202071417" style={{display:'flex',alignItems:'center',padding:'12px 8px',color:'rgba(255,255,255,0.45)',textDecoration:'none',fontSize:14}}>
              📞 0202071417
            </a>
          </div>
        )}
      </nav>

      {/* ── HERO ──────────────────────────────────────────── */}
      <section className="db-hero-bg" style={{minHeight:'100vh',paddingTop:62,position:'relative',overflow:'hidden'}}>
        <Particles mobile={isMobile}/>
        <div style={{maxWidth:1200,margin:'0 auto',padding:isMobile?'44px 20px 56px':'68px 32px 80px',display:'flex',flexDirection:isMobile?'column':'row',alignItems:'center',gap:isMobile?36:52}}>
          <div style={{flex:1,textAlign:isMobile?'center':'left',width:'100%',minWidth:0}}>
            <div className="db-hero-label" style={{display:'inline-flex',alignItems:'center',gap:7,padding:'5px 12px',borderRadius:100,border:'1px solid rgba(221,0,0,0.4)',background:'rgba(221,0,0,0.08)',fontSize:11,fontWeight:600,color:'#FF7777',letterSpacing:'0.7px',textTransform:'uppercase',marginBottom:18}}>
              <span style={{width:5,height:5,borderRadius:'50%',background:R,display:'inline-block',flexShrink:0}}/>
              Ghana's First AI-Powered German School
            </div>
            <h1 className="db-hero-title db-font-display" style={{fontSize:isMobile?'clamp(36px,9.5vw,52px)':'clamp(48px,7vw,82px)',fontWeight:400,lineHeight:1.06,marginBottom:18,color:W}}>
              Learn German.<br/>
              <em className="db-shimmer">Live Fluently.</em>
            </h1>
            <p className="db-hero-sub db-font-body" style={{fontSize:isMobile?14:17,lineHeight:1.65,color:'rgba(255,255,255,0.6)',maxWidth:isMobile?'100%':500,marginBottom:28,marginLeft:isMobile?'auto':0,marginRight:isMobile?'auto':0}}>
              From A1 to B2 — we don't just teach German, we make you <strong style={{color:G}}>LIVE</strong> it.
              AI grading, live cohort classes, TikTok speaking challenges.
            </p>
            <div className="db-hero-btns" style={{display:'flex',flexDirection:isMobile?'column':'row',gap:12,marginBottom:36,alignItems:isMobile?'stretch':'flex-start'}}>
              <Link to="/enroll" style={{display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,padding:'14px 26px',background:R,color:W,borderRadius:10,textDecoration:'none',fontSize:15,fontWeight:700,fontFamily:'Syne,sans-serif',boxShadow:'0 6px 24px rgba(221,0,0,0.3)',minHeight:48,width:isMobile?'100%':'auto',transition:'background 0.2s'}}
                onMouseEnter={e=>e.currentTarget.style.background='#BB0000'}
                onMouseLeave={e=>e.currentTarget.style.background=R}
              >🚀 Enroll Now</Link>
              <button onClick={()=>scrollTo('courses')} style={{display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,padding:'14px 26px',background:'transparent',color:W,border:'1.5px solid rgba(255,255,255,0.28)',borderRadius:10,fontSize:15,fontWeight:600,cursor:'pointer',fontFamily:'Syne,sans-serif',minHeight:48,width:isMobile?'100%':'auto',transition:'all 0.2s'}}
                onMouseEnter={e=>{e.currentTarget.style.borderColor=G;e.currentTarget.style.color=G;}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(255,255,255,0.28)';e.currentTarget.style.color=W;}}
              >View Courses ↓</button>
            </div>
            <div className="db-hero-stats" style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:isMobile?8:24}}>
              <StatCounter value={500}  suffix="+"  label="Students"/>
              <StatCounter value={4}    suffix=""   label="Levels"  />
              <StatCounter value={10}   suffix="wk" label="Duration"/>
              <StatCounter value={20}   suffix=""   label="Max Size"/>
            </div>
          </div>
          {!isMobile&&<div style={{flex:'0 0 auto',display:'flex',justifyContent:'center'}}><HeroVisual/></div>}
          {isMobile&&(
            <div style={{display:'flex',justifyContent:'center',gap:10}}>
              {[B,R,G].map((c,i)=>(
                <div key={i} style={{width:14,height:64,borderRadius:5,background:c,border:c===B?'1px solid rgba(255,255,255,0.14)':'none',boxShadow:c===R?`0 0 20px ${R}66`:c===G?`0 0 14px ${G}44`:'none'}}/>
              ))}
            </div>
          )}
        </div>
        <div style={{position:'absolute',bottom:0,left:0,right:0,height:90,background:`linear-gradient(to bottom,transparent,${B})`,pointerEvents:'none'}}/>
      </section>

      {/* ── ABOUT ─────────────────────────────────────────── */}
      <section style={{background:B,position:'relative'}}>
        <div style={{maxWidth:1200,margin:'0 auto',padding:isMobile?'60px 20px':'96px 32px'}}>
          <div className="db-reveal" style={{textAlign:'center',marginBottom:isMobile?36:56}}>
            <SL text="Our Approach"/>
            <h2 className="db-font-heading" style={{fontSize:isMobile?28:'clamp(30px,5vw,52px)',fontWeight:800,marginTop:8,color:W,lineHeight:1.15}}>
              What is DeutschBridge <span style={{color:G}}>Institute?</span>
            </h2>
            <p style={{maxWidth:540,margin:'14px auto 0',fontSize:isMobile?14:16,lineHeight:1.7,color:'rgba(255,255,255,0.55)'}}>
              DeutschBridge Institute is a Ghanaian-led online German language school that combines live instruction
              with AI-powered tools to prepare students for Goethe-Institut A1–B2 certificate exams.
            </p>
          </div>
          <div style={{display:'grid',gridTemplateColumns:cols('1fr','repeat(3,1fr)','repeat(3,1fr)'),gap:isMobile?14:22}}>
            {[
              {icon:'🎬',title:'TikTok Speaking Challenges',desc:'Record yourself speaking German. Get AI feedback. Build real-world fluency through video, not just tests.',color:R},
              {icon:'🤖',title:'AI-Powered Learning',desc:'Claude AI grades your writing, explains your mistakes, and gives you a corrected version instantly.',color:G},
              {icon:'🌍',title:'Real World Tasks',desc:'Practice ordering food, writing emails, navigating airports — in German. Because language is for living.',color:W},
            ].map((f,i)=>(
              <TiltCard key={i} isMobile={isMobile} className="db-reveal" style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:14,padding:isMobile?'22px 18px':'28px 24px'}}>
                <div style={{fontSize:34,marginBottom:12}}>{f.icon}</div>
                <h3 className="db-font-heading" style={{fontSize:16,fontWeight:700,color:f.color,marginBottom:8}}>{f.title}</h3>
                <p style={{fontSize:13,lineHeight:1.65,color:'rgba(255,255,255,0.5)'}}>{f.desc}</p>
              </TiltCard>
            ))}
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ──────────────────────────────────── */}
      <section style={{background:'#111',position:'relative'}}>
        <div style={{maxWidth:1200,margin:'0 auto',padding:isMobile?'60px 20px':'96px 32px'}}>
          <div className="db-reveal" style={{textAlign:'center',marginBottom:isMobile?40:64}}>
            <SL text="Simple Steps" color={G}/>
            <h2 className="db-font-heading" style={{fontSize:isMobile?28:'clamp(30px,5vw,52px)',fontWeight:800,marginTop:8,color:W}}>
              Your Journey to <span style={{color:R}}>Fluency</span>
            </h2>
          </div>
          <div className={isMobile?'':'db-step-line-h'} style={{display:'grid',gridTemplateColumns:isMobile?'1fr':'repeat(4,1fr)',gap:isMobile?0:24,position:'relative'}}>
            {[
              {n:'01',title:'Fill Enroll Form',desc:'Submit your interest form with your name, email, level and phone number.',icon:'📝'},
              {n:'02',title:'Pay for Your Level',desc:'Make payment to Access Bank Ghana and send receipt via WhatsApp.',icon:'💳'},
              {n:'03',title:'Get Your Account',desc:'We create your account and send login details within 24 hours.',icon:'🏫'},
              {n:'04',title:'Speak German!',desc:'Attend live classes, complete TikTok tasks, ace the Goethe exam.',icon:'🎓'},
            ].map((s,i)=>(
              <div key={i} className="db-reveal" style={{position:'relative',display:'flex',flexDirection:isMobile?'row':'column',alignItems:isMobile?'flex-start':'center',textAlign:isMobile?'left':'center',gap:isMobile?14:0,padding:isMobile?'18px 0':0,borderBottom:isMobile&&i<3?'1px solid rgba(255,255,255,0.07)':'none'}}>
                {isMobile?(
                  <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:6,flexShrink:0,width:48}}>
                    <div style={{width:38,height:38,borderRadius:'50%',background:i===0?R:'rgba(255,255,255,0.06)',border:`2px solid ${i===0?R:'rgba(255,255,255,0.12)'}`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:800,color:W,fontFamily:'Syne,sans-serif'}}>
                      {s.n}
                    </div>
                    <div style={{fontSize:22}}>{s.icon}</div>
                  </div>
                ):(
                  <>
                    <div style={{display:'inline-flex',alignItems:'center',justifyContent:'center',width:48,height:48,borderRadius:'50%',background:i===0?R:'rgba(255,255,255,0.06)',border:`2px solid ${i===0?R:'rgba(255,255,255,0.12)'}`,fontSize:13,fontWeight:800,color:W,fontFamily:'Syne,sans-serif',marginBottom:10,position:'relative',zIndex:1}}>
                      {s.n}
                    </div>
                    <div style={{fontSize:32,marginBottom:10}}>{s.icon}</div>
                  </>
                )}
                <div style={{flex:1}}>
                  <h3 className="db-font-heading" style={{fontSize:15,fontWeight:700,color:W,marginBottom:5}}>{s.title}</h3>
                  <p style={{fontSize:13,lineHeight:1.6,color:'rgba(255,255,255,0.46)'}}>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── COURSES ───────────────────────────────────────── */}
      <section id="courses" style={{background:B,position:'relative'}}>
        <div style={{maxWidth:1200,margin:'0 auto',padding:isMobile?'60px 20px':'96px 32px'}}>
          <div className="db-reveal" style={{textAlign:'center',marginBottom:isMobile?36:56}}>
            <SL text="Enroll Today"/>
            <h2 className="db-font-heading" style={{fontSize:isMobile?28:'clamp(30px,5vw,52px)',fontWeight:800,marginTop:8,color:W}}>
              Our <span style={{color:G}}>Courses</span>
            </h2>
          </div>
          <div style={{display:'grid',gridTemplateColumns:cols('1fr','repeat(2,1fr)','repeat(4,1fr)'),gap:isMobile?14:20}}>
            {[
              {level:'A1',name:'Beginner',         price:'3,550',weeks:10,color:G,features:['Basic greetings & phrases','Numbers and alphabet','Simple conversations','Goethe Fit A1 Prep']},
              {level:'A2',name:'Elementary',        price:'3,999',weeks:12,color:R,features:['Daily routines','Shopping & travel','Past tense mastery','Goethe A2 Prep']},
              {level:'B1',name:'Intermediate',      price:'4,200',weeks:14,color:W,features:['Opinions & discussions','Work and career German','Complex grammar','Goethe B1 Prep']},
              {level:'B2',name:'Upper Intermediate',price:'4,500',weeks:16,color:G,features:['Advanced discourse','Academic writing','Idiomatic expressions','Goethe B2 Prep']},
            ].map((c,i)=>(
              <TiltCard key={i} isMobile={isMobile} className="db-reveal" style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(255,255,255,0.07)',borderTop:`3px solid ${c.color}`,borderRadius:13,padding:isMobile?'20px 16px 16px':'24px 20px 18px',display:'flex',flexDirection:'column'}}>
                <div style={{marginBottom:16}}>
                  <span style={{display:'inline-block',padding:'3px 10px',background:c.color===W?'rgba(255,255,255,0.1)':`${c.color}22`,color:c.color,borderRadius:5,fontSize:11,fontWeight:800,fontFamily:'Syne,sans-serif',letterSpacing:'1px'}}>{c.level}</span>
                  <h3 className="db-font-heading" style={{fontSize:17,fontWeight:700,color:W,marginTop:8,marginBottom:4}}>{c.name}</h3>
                  <div style={{display:'flex',alignItems:'baseline',gap:6,flexWrap:'wrap'}}>
                    <span style={{fontSize:22,fontWeight:800,color:c.color,fontFamily:'Syne,sans-serif'}}>GHS {c.price}</span>
                    <span style={{fontSize:12,color:'rgba(255,255,255,0.36)'}}>· {c.weeks} wks</span>
                  </div>
                </div>
                <ul style={{listStyle:'none',padding:0,margin:'0 0 18px',flex:1}}>
                  {c.features.map((f,j)=>(
                    <li key={j} style={{display:'flex',alignItems:'flex-start',gap:6,fontSize:13,color:'rgba(255,255,255,0.56)',marginBottom:6}}>
                      <span style={{color:c.color,flexShrink:0,marginTop:1}}>✓</span>{f}
                    </li>
                  ))}
                </ul>
                <Link to="/enroll" style={{display:'flex',alignItems:'center',justifyContent:'center',padding:'11px',background:R,color:W,borderRadius:7,textDecoration:'none',fontSize:13,fontWeight:700,fontFamily:'Syne,sans-serif',minHeight:44}}
                  onMouseEnter={e=>e.currentTarget.style.background='#BB0000'}
                  onMouseLeave={e=>e.currentTarget.style.background=R}
                >Enroll in {c.level} →</Link>
              </TiltCard>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY DEUTSCHBRIDGE ─────────────────────────────── */}
      <section style={{background:'#0F0F0F',position:'relative'}}>
        <div style={{maxWidth:1200,margin:'0 auto',padding:isMobile?'60px 20px':'96px 32px'}}>
          <div className="db-reveal" style={{textAlign:'center',marginBottom:isMobile?36:56}}>
            <SL text="Why Us" color={G}/>
            <h2 className="db-font-heading" style={{fontSize:isMobile?28:'clamp(30px,5vw,52px)',fontWeight:800,marginTop:8,color:W}}>
              Why Choose <span style={{color:R}}>DeutschBridge?</span>
            </h2>
          </div>
          <div style={{display:'grid',gridTemplateColumns:cols('1fr','repeat(2,1fr)','repeat(3,1fr)'),gap:isMobile?12:16}}>
            {[
              {icon:'🗣️',title:'Fluency First',      desc:"Speak from day one. Task-based learning means you're communicating in German before you know it.",accent:R},
              {icon:'📜',title:'Goethe Exam Prep',   desc:'All courses align with the official Goethe-Institut exam structure — A1 to B2 certification.',accent:G},
              {icon:'💻',title:'Live Classes',        desc:'Weekly Google Meet sessions with experienced teachers. Real-time corrections, real progress.',accent:W},
              {icon:'👥',title:'Small Cohorts',       desc:'Maximum 20 students per class so every student gets personal attention. Quality over quantity.',accent:G},
              {icon:'🤖',title:'AI Grading',          desc:'Instant feedback on your writing. Score, errors, corrections, and an improved version — instantly.',accent:R},
              {icon:'🇬🇭',title:'Built in Ghana',    desc:"Created by Ghanaians for Africans going to Germany. We understand your journey because we've walked it.",accent:G},
            ].map((f,i)=>(
              <div key={i} className="db-reveal" style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(255,255,255,0.07)',borderRadius:12,padding:isMobile?'18px 16px':'20px'}}>
                <div style={{fontSize:28,marginBottom:10}}>{f.icon}</div>
                <h3 className="db-font-heading" style={{fontSize:14,fontWeight:700,color:f.accent,marginBottom:6}}>{f.title}</h3>
                <p style={{fontSize:13,lineHeight:1.62,color:'rgba(255,255,255,0.46)'}}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ──────────────────────────────────── */}
      <section style={{background:B,position:'relative'}}>
        <div style={{maxWidth:1200,margin:'0 auto',padding:isMobile?'60px 20px':'96px 32px'}}>
          <div className="db-reveal" style={{textAlign:'center',marginBottom:isMobile?36:56}}>
            <SL text="Student Stories"/>
            <h2 className="db-font-heading" style={{fontSize:isMobile?28:'clamp(28px,4vw,48px)',fontWeight:800,marginTop:8,color:W}}>
              What Our Students <span style={{color:G}}>Say</span>
            </h2>
          </div>
          <div style={{display:'grid',gridTemplateColumns:cols('1fr','repeat(3,1fr)','repeat(3,1fr)'),gap:isMobile?14:20}}>
            {[
              {name:'Abena K.',level:'Completed A2',quote:'"I passed my Goethe A2 on the first attempt! The TikTok speaking challenges made me so confident speaking German in real life."'},
              {name:'Kweku M.',level:'Currently B1', quote:'"The AI grading is unbelievable. It gives you a corrected version of your writing instantly. I improved faster than I ever expected."'},
              {name:'Ama O.',  level:'Completed A1', quote:'"From zero German to holding a conversation in 10 weeks. The cohort system and small class made all the difference."'},
            ].map((t,i)=>(
              <TiltCard key={i} isMobile={isMobile} className="db-reveal" style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:13,padding:isMobile?'20px 16px':'24px'}}>
                <div style={{color:G,fontSize:13,marginBottom:12,letterSpacing:'2px'}}>★★★★★</div>
                <p style={{fontSize:14,lineHeight:1.7,color:'rgba(255,255,255,0.66)',fontStyle:'italic',marginBottom:16}}>{t.quote}</p>
                <div style={{display:'flex',alignItems:'center',gap:10}}>
                  <div style={{width:36,height:36,borderRadius:'50%',flexShrink:0,background:`linear-gradient(135deg,${R},#8B0000)`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:14,fontWeight:700,color:W,fontFamily:'Syne,sans-serif'}}>{t.name.charAt(0)}</div>
                  <div>
                    <div className="db-font-heading" style={{fontSize:13,fontWeight:700,color:W}}>{t.name}</div>
                    <div style={{fontSize:11,color:G,fontWeight:600}}>{t.level}</div>
                  </div>
                </div>
              </TiltCard>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA / CONTACT ─────────────────────────────────── */}
      <section id="contact" style={{background:R,position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',inset:0,opacity:0.04,backgroundImage:'repeating-linear-gradient(0deg,transparent,transparent 40px,rgba(0,0,0,0.5) 40px,rgba(0,0,0,0.5) 41px),repeating-linear-gradient(90deg,transparent,transparent 40px,rgba(0,0,0,0.5) 40px,rgba(0,0,0,0.5) 41px)',pointerEvents:'none'}}/>
        <div style={{maxWidth:840,margin:'0 auto',padding:isMobile?'60px 20px':'96px 32px',textAlign:'center',position:'relative'}}>
          <div className="db-reveal">
            <div className="db-flag" style={{width:34,height:24,margin:'0 auto 18px',boxShadow:'0 2px 8px rgba(0,0,0,0.3)'}}>
              <div style={{flex:1,background:B}}/><div style={{flex:1,background:R,filter:'brightness(0.7)'}}/><div style={{flex:1,background:G}}/>
            </div>
            <h2 className="db-font-heading" style={{fontSize:isMobile?'clamp(24px,8vw,34px)':'clamp(32px,5vw,60px)',fontWeight:800,color:W,lineHeight:1.1,marginBottom:14}}>
              Ready to Start<br/>Speaking German?
            </h2>
            <p style={{fontSize:isMobile?14:16,color:'rgba(255,255,255,0.78)',marginBottom:28,lineHeight:1.65}}>
              Join hundreds of Ghanaians preparing for Goethe-Institut certification.
              Enroll today — live classes, AI grading, and your cohort await.
            </p>
            <div style={{display:'flex',flexDirection:isMobile?'column':'row',justifyContent:'center',alignItems:'center',gap:isMobile?10:24,marginBottom:28}}>
              <a href="tel:0202071417" style={{color:W,textDecoration:'none',fontSize:15,fontWeight:600,display:'flex',alignItems:'center',gap:6,minHeight:44}}>📞 0202071417</a>
              <a href="mailto:deutschbridgeinstitute@gmail.com" style={{color:W,textDecoration:'none',fontSize:isMobile?12:15,fontWeight:600,display:'flex',alignItems:'center',gap:6,minHeight:44,wordBreak:'break-all'}}>✉️ deutschbridgeinstitute@gmail.com</a>
            </div>
            <Link to="/enroll" style={{display:isMobile?'flex':'inline-flex',alignItems:'center',justifyContent:'center',padding:'16px 36px',background:B,color:W,borderRadius:11,textDecoration:'none',fontSize:16,fontWeight:800,fontFamily:'Syne,sans-serif',boxShadow:'0 8px 28px rgba(0,0,0,0.3)',minHeight:56,width:isMobile?'100%':'auto'}}
              onMouseEnter={e=>e.currentTarget.style.background='#111'}
              onMouseLeave={e=>e.currentTarget.style.background=B}
            >Enroll Now — Viel Erfolg! 🇩🇪</Link>
          </div>
        </div>
      </section>

      {/* ── FOOTER ────────────────────────────────────────── */}
      <footer style={{background:'#0A0A0A',padding:isMobile?'36px 20px 18px':'44px 32px 22px'}}>
        <div style={{maxWidth:1200,margin:'0 auto'}}>
          <div style={{display:'flex',flexDirection:isMobile?'column':'row',justifyContent:'space-between',alignItems:'flex-start',gap:isMobile?24:28,marginBottom:24}}>
            <div>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                <div className="db-flag" style={{width:20,height:14}}><div style={{flex:1,background:B,border:'1px solid rgba(255,255,255,0.1)'}}/><div style={{flex:1,background:R}}/><div style={{flex:1,background:G}}/></div>
                <span className="db-font-heading" style={{fontSize:15,fontWeight:800}}><span style={{color:G}}>Deutsch</span><span style={{color:W}}>Bridge</span></span>
              </div>
              <p style={{fontSize:13,color:'rgba(255,255,255,0.35)',maxWidth:220,lineHeight:1.6}}>
                Ghana's first AI-powered German language school. A1–B2 certification prep.
              </p>
            </div>
            <div style={{display:'flex',gap:isMobile?28:36}}>
              {[
                {label:'Platform',links:[{text:'Login',to:'/login'},{text:'Enroll',to:'/enroll'}]},
                {label:'Contact', links:[{text:'0202071417',href:'tel:0202071417'},{text:'Email Us',href:'mailto:deutschbridgeinstitute@gmail.com'}]},
              ].map(col=>(
                <div key={col.label}>
                  <p className="db-font-heading" style={{fontSize:10,fontWeight:700,letterSpacing:'1.5px',textTransform:'uppercase',color:'rgba(255,255,255,0.26)',marginBottom:10}}>{col.label}</p>
                  <ul style={{listStyle:'none',padding:0,margin:0}}>
                    {col.links.map(l=>(
                      <li key={l.text} style={{marginBottom:8}}>
                        {l.to?(
                          <Link to={l.to} style={{color:'rgba(255,255,255,0.42)',textDecoration:'none',fontSize:13}}>{l.text}</Link>
                        ):(
                          <a href={l.href} style={{color:'rgba(255,255,255,0.42)',textDecoration:'none',fontSize:13}}>{l.text}</a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
          <div style={{borderTop:'1px solid rgba(255,255,255,0.06)',paddingTop:18}}>
            <div style={{display:'flex',height:3,borderRadius:2,overflow:'hidden',marginBottom:14,width:90}}>
              <div style={{flex:1,background:B,border:'1px solid rgba(255,255,255,0.1)'}}/><div style={{flex:1,background:R}}/><div style={{flex:1,background:G}}/>
            </div>
            <p style={{fontSize:12,color:'rgba(255,255,255,0.2)'}}>© 2026 DeutschBridge Institute. All rights reserved. · Made in Ghana 🇬🇭</p>
          </div>
        </div>
      </footer>
    </div>
  );
}